import React, { useState } from "react";
import axios from "axios";
// import logo from '../../../assets/users/helene-engels.png'
import Input from '../../../../components/Form/Input'
// import ButtonHoverAnimated from '../../../../components/Buttons/ButtonHoverAnimated'
// import ImagePicker from '../../../../components/ImagePicker'
// import Select from '../../../../components/Form/Select'
// import TextAreaEditor  from "../../../../components/Form/TextAreaEditor"
import { api } from "../../../../../api"
import { useOutletContext } from 'react-router-dom'
import ButtonBlack from "../../../../components/Buttons/ButtonBlack";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../../../redux/userSlice";

function AccountSettings({ option }) {
  const [email, setEmail] = useState("johndoe@gmail.com")
  const [newEmail, setNewEmail] = useState("")
  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [message, setMessage] = useState("")
  const {showNotif, setShowNotif} = useOutletContext()
  const [isLoading1, setIsLoading1] = useState(false)
  const [isLoading2, setIsLoading2] = useState(false)
  const { user } = useSelector((store) => store.user);
  const dispatch = useDispatch()

  const handleChangeEmail = async () => { 
    console.log("User ID:", user?.id); 
    // console.log("Old Email:", oldEmail); 
    console.log("New Email:", newEmail);

    setIsLoading1(true);
    await axios.put(`${api}/email/update/${2}`, { // Assure-toi que user?.id est bien défini
        // oldEmail: oldEmail, // Vérifie que cette valeur est correcte
        newEmail: newEmail 
    })
    .then((response) => {
        setEmail(newEmail);
        console.log(response.data);
        if(response.data?.user)dispatch(updateUser(response.data?.user));
        setIsLoading1(false);
        setShowNotif({ ...showNotif, variant: "success", message: "Email mis à jour avec succès !", show: true });
    })      
    .catch((error) => {
        console.log("Erreur API:", error.response?.data); // Log l'erreur précise de Laravel
        setIsLoading1(false);
        setShowNotif({ ...showNotif, variant: "danger", message: "Une erreur est survenue", show: true });
    });
};


  const handleChangePassword = async () => {
  setIsLoading2(true)
    // await axios.put(api+"/user/changePassword/"+2, { // A MODIFIER user?.id
    //   oldPassword : oldPassword,
    //   newPassword : newPassword,
    //   })
      
      await axios.put(`${api}/user/changePassword/${2}`, 
        { oldPassword, newPassword }, 
        { headers: { "Content-Type": "application/json" } }
    )
    .then((response)=>{
        setEmail(newEmail);
        console.log(response.data)
        if(response.data?.user)dispatch(updateUser(response.data?.user));
        setIsLoading2(false)
        setShowNotif({...showNotif, variant: "success", message:"Mise à jour réussie !", show: true})
      })      
      .catch( (error)=> {
        console.log(error)
        setIsLoading2(false)
        setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
      })
  };

  const handleDeactivateAccount = async () => {
    const confirmDeactivation = window.confirm(
      "Êtes-vous sûr de vouloir désactiver votre compte ?"
    );
    if (confirmDeactivation) {
      try {
        const response = await axios.delete("/api/user/deactivate");
        setMessage("Compte désactivé avec succès.");
      } catch (error) {
        setMessage("Erreur lors de la désactivation du compte.");
      }
    }
  };

  return (
    <>
      {option === 2 && (
        <>
          {message && <div className="text-sm text-green-600">{message}</div>}

          {/* Update Email Section */}
          <div className="grid grid-cols-5 gap-4 py-6">
            <div className="text-sm text-start space-y-2 col-span-2">
              <h2 className="font-semibold text-sm">Adresse email</h2>
              <p className="text-sm text-primary-text">
                Consultez ou mettez à jour votre adresse email associée à votre compte.
              </p>
            </div>
            <div className="col-span-3 space-y-4">
              <div className="text-sm text-start space-y-2">
                <h2 className="font-semibold text-sm">{user?.email}</h2>
                <p className="text-sm text-primary-text">
                  Votre adresse email a été vérifiée.
                </p>
              </div>
              <Input
                type="email"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                placeholder="Nouveau email"
                className="input"
              />
              <div className="flex justify-end my-4">
                 <ButtonBlack
                  isLoading={isLoading1}
                  onClick={handleChangeEmail}
                  // className="text-xs px-6 py-2.5 rounded-md bg-primary-black text-white"
                >
                  Modifier
                </ButtonBlack>
              </div>
            </div>
          </div>

          {/* Update Password Section */}
          <div className="grid grid-cols-5 gap-4 py-6">
            <div className="text-sm text-start space-y-2 col-span-2">
              <h2 className="font-semibold text-sm">Sécurité du compte</h2>
              <p className="text-sm text-primary-text">
                Mettez à jour votre mot de passe pour renforcer la sécurité de votre compte.
              </p>
            </div>
            <div className="col-span-3 space-y-4">
              <Input
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Ancien mot de passe"
                className="input"
              />
              <Input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nouveau mot de passe"
                className="input"
              />
              <div className="flex justify-end my-4">
                <ButtonBlack
                  isLoading={isLoading2}
                  onClick={handleChangePassword}
                  // className="text-xs px-6 py-2.5 rounded-md bg-primary-black text-white"
                >
                  Modifier
                </ButtonBlack>
              </div>
            </div>
          </div>

          {/* Deactivate Account Section */}
          <div className="flex justify-end py-6">
            <button
              onClick={handleDeactivateAccount}
              className="text-red-600 text-sm flex items-center gap-1"
            >
              Désactiver un compte
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_98_23157)">
                  <path
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                    stroke="#FF6550"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 8H12.01"
                    stroke="#FF6550"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11 12H12V16H13"
                    stroke="#FF6550"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_98_23157">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default AccountSettings;
